<template>
  <div class="profile">
    <van-nav-bar
      title="绑定手机号"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <van-cell-group>
      <van-field
        v-model="bindData.mobile"
        clearable
        type="tel"
        maxlength="11"
        label="手机"
        placeholder="请输入手机号"
      />
      <van-field
        v-model="bindData.code"
        center
        clearable
        label="验证码"
        placeholder="请输入短信验证码"
      >
        <van-button slot="button" plain size="small" type="danger" :disabled="!canSend" @click="send">{{sendBtnText}}</van-button>
      </van-field>
    </van-cell-group>

    <bottom-btn class="bgwhite" title="保存" :fixed="false" @click.native="gotoSave" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Field, Cell, CellGroup, Toast, NavBar, Button } from 'vant'
import BottomBtn from '@/components/BottomBtn'
import { sendSms, bindMobile } from '@/api/account'

export default {
  name: 'bindmobile',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    BottomBtn
  },
  data () {
    return {
      bindData: {
        mobile: '',
        code: ''
      },
      countdown: 0,
      interval: null
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ]),
    canSend () {
      const re = /^1\d{10}$/
      return re.test(this.bindData.mobile) && this.countdown === 0
    },
    sendBtnText () {
      if (this.countdown === 0) {
        return '发送验证码'
      } else {
        return `重新发送(${this.countdown})`
      }
    }
  },
  created () {
  },
  methods: {
    async gotoSave () {
      if (!this.bindData.mobile) {
        Toast('手机号不能为空')
        return
      }
      if (!this.bindData.code) {
        Toast('验证码不能为空')
        return
      }
      console.log(1111)
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      await bindMobile(this.bindData)
      await this.$store.dispatch('GetUserInfo')
      Toast.clear()

      Toast('绑定成功')

      const path = this.$route.query.path
      if (path) {
        this.$router.replace(path)
      } else {
        this.$router.replace('/my')
      }
    },
    async send () {
      if (!this.bindData.mobile) {
        Toast('手机号不能为空')
        return
      }

      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      await sendSms({
        mobile: this.bindData.mobile
      })
      Toast.clear()

      this.resetCountDown()
      this.interval = setInterval(() => {
        this.countdown -= 1
        if (this.countdown === 0) {
          clearInterval(this.interval)
        }
      }, 1010)
    },
    resetCountDown () {
      this.countdown = 60
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.profile {
  background-color: #f8f8f8;
  .title {
    font-size: 28px;
    color: rgba(69,90,100,.6);
    padding: 15px 0 15px 20px;
  }
}
</style>
